export const Types = {
  GET_REQUEST: 'sites/GET_REQUEST',
  GET_SUCCESS: 'sites/GET_SUCCESS',
};

const INITIAL_STATE = {
  data: {
    custom_css: null,
    name: '',
    logo: null,
    description: null,
    base_url: null,
    favicon: null,
  },
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET_REQUEST:
      return { ...state, loading: true };
    case Types.GET_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return { data: action.payload.data, loading: false, error: null };
    default:
      return state;
  }
};

export const Creators = {
  getSiteRequest: () => ({ type: Types.GET_REQUEST }),
  getSiteSuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: { data },
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/sites.js